
import { Component, ElementRef } from '@angular/core';
import { Broadcaster } from '../service/Broadcaster';
import { SingService } from '../service/sing.service';

@Component({
    selector: 'support-comp',
    templateUrl: 'index.html',
    styleUrls: ['css/style.css'],
    providers: [SingService]
})
export class SupportComponent {
    message: string = "";
    linkPhoto: string = "";
    constructor(
        private broadcaster: Broadcaster,
        private elementRef: ElementRef,
        private httpService: SingService
    ) { }
    ngOnInit() {

        this.elementRef.nativeElement.querySelector('.support-closed').addEventListener(
            'click',
            (event) => {

            }, false);
        this.elementRef.nativeElement.querySelector('.support-body button').addEventListener(
            'click',
            (event) => {

            }, false);


    }
    closedSupport() {
        (<HTMLElement>document.body.querySelector('.allwhite')).style.display = 'none';
        document.body.querySelector('main.content').classList.remove('m--blur');
        this.elementRef.nativeElement.querySelector('.support').style.display = 'none';

    }
}


// WEBPACK FOOTER //
// ./src/app/components/support/support.component.ts